<template>
  <div style="background-color: #fff;min-height: 100vh">
    <headNav>
      <div slot="headNavText">{{$t('message.yys_rz')}}</div>
    </headNav>
    <div class="container">
      <div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle circle1">03</div>
        <div class="circle"></div>
      </div>
      <div class="scsf">
        <div>{{$t('message.yys_rz')}}</div>
        <div>{{$t('message.yys_tip')}}</div>
      </div>

      <div class="choose">
        <h3>{{$t('message.choose_yys')}}</h3>
        <div class="yys_item"  @click="goYYSsend('ais')">
          <div>Ais</div>
          <div style="display: flex;align-items: center">คลิกเพื่ออนุญ<van-icon name="arrow" /></div>
        </div>
        <div class="yys_item" @click="goYYSsend('dtac')">
          <div>Dtac</div>
          <div style="display: flex;align-items: center">คลิกเพื่ออนุญ<van-icon name="arrow" /></div>
        </div>
        <div class="yys_item" @click="goYYSsend('true')">
          <div>True</div>
          <div style="display: flex;align-items: center">คลิกเพื่ออนุญ<van-icon name="arrow" /></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import headNav from "../../../HeadNav/headNav";
  export default {
    name: "yys",
    data(){
      return{
        canOver:false
      }
    },
    components:{
      headNav
    },
    methods:{
      goYYSsend(a) {
        this.$router.push({path: '/yys_send', query: {type: a}})
      },
    }
  }
</script>

<style scoped lang="scss">
  .btns {
    @include defaultBtn;
    margin: 0.5rem 0 0.2rem;
  }
  .container {
    padding: 1.6rem 15px 0.5rem;
    background-color: #fff;
    .circle {
      width: 0.19rem;
      height: 0.19rem;
      background-color: #D5D5D5;
      border-radius: 0.19rem;
      display: inline-block;
      margin-right: 5px;
    }

    .circle1 {
      width: 0.53rem;
      height: 0.53rem;
      background: $color;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 0.53rem;
    }

    .scsf {
      & :nth-child(1) {
        font-size: 0.53rem;
        font-weight: 600;
        color: #014CCC;
        margin: 0.36rem 0 0.3rem;
      }

      & :nth-child(2) {
        font-size: 0.37rem;
        font-weight: 300;
        color: #878686;
      }
      ~div{
        text-align: center;
        margin-top:1rem ;
        img{
          height: 5.47rem;
          width: 2.83rem;
        }
      }
    }
    .tips{
      margin-top:1rem!important;
      text-align: left!important;
      h3{
        color: #242424;
        font-size: 0.37rem;
        font-weight: 500;
      }
      div{
        font-size: 0.32rem;
        font-weight: 400;
        color: #878686;
        padding:0.15rem 0
      }
    }
    .choose{
      text-align: left!important;
      .yys_item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #DEE2E8;
        padding: 15px 10px;
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/personInfo/yys/chooseYYS.vue